<template>
    <CardShell>
        <BackLinkHeading route="/invoices" linkText="Invoices" :sizeDependent="false" text="Invoice #093247786234" class="mb3"/>
        <div class="ph3 ph4-ns pb4">
            <ChargeSummary :invoice="invoice"/>
            <TransactionSummary class="mt3"/>
        </div>
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import ChargeSummary from '@/components/rent/shared/chargeSummary/ChargeSummary.vue';
import TransactionSummary from '@/components/rentalsListings/invoices/TransactionSummary.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CardShell,
        BackLinkHeading,
        ChargeSummary,
        TransactionSummary
    },
    computed: {
        ...mapState('invoices', ['chargeDetail', 'loadingTransactionDetail']),
        invoice() {
            return {
                fees: [
                    {
                        heading: 'Rental Price',
                        description: '',
                        price: parseFloat(this.chargeDetail.rentalPrice)
                    },
                    ...this.chargeDetail.fees.map(fee => {
                        return {
                            heading: fee.title,
                            description: fee.description,
                            price: parseFloat(fee.price)
                        };
                    }),
                    {
                        heading: 'Delivery',
                        description: 'delivery charge...',
                        price: parseFloat(this.chargeDetail.deliveryFee)
                    },
                    {
                        heading: 'Tooliaba Service Fee & Taxes',
                        description: 'tooliaba service fee...',
                        price: parseFloat(this.chargeDetail.serviceFee)
                    }
                ],
                refundableFees: [
                    {
                        heading: 'Refundable Deposit',
                        description: 'refundable deposit....',
                        price: parseFloat(this.chargeDetail.deposit)
                    }
                ]
            };
        }
    }
};
</script>
